export default class TeamModal {
  constructor(el) {
    this.el = el;
    this.cards = [...el.querySelectorAll('.team-card')];
    this.lastFocus = null;

    this.build();
    this.bind();
  }

  build() {
    this.modal = document.createElement('div');
    this.modal.className = 'team-modal';
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.innerHTML = `
            <div class="team-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="team-modal-name">
                <button class="team-modal__close" type="button" aria-label="Fermer">
                    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.2">
                        <path d="M3 3l18 18M21 3L3 21" />
                    </svg>
                </button>

                <div class="team-modal__info">
                    <p class="team-modal__tagline"></p>
                    <h2 class="team-modal__name" id="team-modal-name"></h2>
                    <p class="team-modal__role"></p>
                    <p class="team-modal__bio"></p>
                </div>

                <div class="team-modal__image">
                    <img src="" alt="" />
                </div>
            </div>
        `;
    document.body.appendChild(this.modal);

    this.dialog = this.modal.querySelector('.team-modal__dialog');
    this.closeBtn = this.modal.querySelector('.team-modal__close');
    this.refs = {
      tagline: this.modal.querySelector('.team-modal__tagline'),
      name: this.modal.querySelector('.team-modal__name'),
      role: this.modal.querySelector('.team-modal__role'),
      bio: this.modal.querySelector('.team-modal__bio'),
      img: this.modal.querySelector('.team-modal__image img'),
    };
  }

  bind() {
    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.open(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.open(card);
        }
      });
    });

    this.closeBtn.addEventListener('click', () => this.close());

    // click on the backdrop (outside the dialog) closes
    this.modal.addEventListener('click', (e) => {
      if (!this.dialog.contains(e.target)) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'Tab') {
        // only one focusable element: keep focus on the close button
        e.preventDefault();
        this.closeBtn.focus();
      }
    });
  }

  open(card) {
    const { tagline, name, role, bio, image } = card.dataset;

    this.refs.tagline.textContent = tagline || '';
    this.refs.name.textContent = name || '';
    this.refs.role.textContent = role || '';
    this.refs.bio.textContent = bio || '';
    this.refs.img.src = image || '';
    this.refs.img.alt = name ? `Portrait de ${name}` : '';

    this.lastFocus = document.activeElement;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('modal-open');
    this.closeBtn.focus();
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('modal-open');
    if (this.lastFocus) this.lastFocus.focus();
  }
}
